import React from "react";
import { ModalBody, Label, Input, Checkbox, Common } from "@lainco/react-toolbox";
import { withCrudModal } from "../components/Modal";
import BankAccountType from "../model/BankAccountType";

export function BankAccountTypeModalContent({ model, onChange }) {
  return (
    <ModalBody>
      <Label text="Spanish Name">
        <Input value={model.spanishName} onChange={(x) => onChange({ ...model, spanishName: x })} />
      </Label>
      <Label text="English Name">
        <Input value={model.englishName} onChange={(x) => onChange({ ...model, englishName: x })} />
      </Label>
      <Common.Row cols="1fr 1fr" gap="1em">
        <Label text="Has Interest">
          <Checkbox checked={model.hasInterest} onChange={(x) => onChange({ ...model, hasInterest: x })} />
        </Label>
      </Common.Row>
    </ModalBody>
  );
}

export default withCrudModal(BankAccountTypeModalContent, BankAccountType, "md", false);
